export var STATE_SET_STATE_TYPE = 'state/setState';
export var STATE_RESET_TO_PHONE_AUTH = 'state/resetToPhoneAuth';
export var STATE_RESET_TO_USERNAME_AUTH = 'state/resetToUsernameAuth';